__turbopack_context__.v({
  "category": "FiltredCategories-module-scss-module__cRl0wW__category",
  "image": "FiltredCategories-module-scss-module__cRl0wW__image",
  "root": "FiltredCategories-module-scss-module__cRl0wW__root",
  "slide": "FiltredCategories-module-scss-module__cRl0wW__slide",
});
